import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import { ACCOUNT_PROFILE_PATH } from 'bundles/account-profile/common/constants';
import AccountProfileApp from 'bundles/account-profile/components/AccountProfileApp';
import {
  PROFILE_BY_EXTERNALID_PREFIX,
  PROFILE_BY_SLUG_PREFIX,
} from 'bundles/account-profile/components/recruiting-profile-viewer/utils/profileSlugUtils';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

import 'css!bundles/account-profile/styl/index';

const AccountProfileEditorPage = () => import('bundles/account-profile/components/AccountProfileEditorPage');
const AccountProfileViewerPage = () => import('bundles/account-profile/components/AccountProfileViewerPage');

const routes = (
  <CourseraRoute
    path="/"
    component={AccountProfileApp}
    handle={{ tracking: { data: () => ({ page: { type: 'learner_profile' } }) } }}
  >
    <Route path={ACCOUNT_PROFILE_PATH} getComponent={loadOnRoute(AccountProfileEditorPage)} />
    <Route path={`/${PROFILE_BY_EXTERNALID_PREFIX}/:externalId`} getComponent={loadOnRoute(AccountProfileViewerPage)} />
    <Route path={`/${PROFILE_BY_SLUG_PREFIX}/:slug`} getComponent={loadOnRoute(AccountProfileViewerPage)} />
    <Route path="*" component={NotFound} />
  </CourseraRoute>
);

export default routes;
